import { isLightColor, Text } from "@mantine/core"
import { getStripedGradientRuleFromColor } from "../../../../../utils/getStripedGradientRule"
import { FormattedText } from "../../../../../@client/Theasoft_Framework"
import { TsCellStyle } from "../../../../../@client/Theasoft_Core"
import { Cell } from "@/orval/gen/model"

function renderCellText(text: FormattedText[], _: TsCellStyle) {
  return text?.map((v, i) => (
    <Text
      key={i}
      span
      size="xs"
      style={{ alignSelf: "center", flex: 1 }}
      fs={v.format?.font.italic ? "italic" : undefined}
    >
      {i > 0 ? ", " : null}
      {v.text + ""}
    </Text>
  ))
}

export function renderContent(cell: Cell) {
  const dutyRosters = cell.dutyRosters?.flatMap((v) =>
    v.shifts?.map((s, i) =>
      s.label ? (
        <div
          key={i}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: "1",
            backgroundColor: s.bg as any,
            color: s.bg && isLightColor(s.bg) ? "black" : undefined,
            flex: "1",
          }}
        >
          {s.label}
        </div>
      ) : null
    )
  )

  const absences = cell.absences?.map((v, i) => {
    return (
      <div
        key={i}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background:
            v.isPending && v.bg
              ? getStripedGradientRuleFromColor(
                  v.bg,
                  "light-dark(var(--mantine-color-gray-5),var(--mantine-color-dark-6))"
                )
              : v.bg || undefined,

          color: v.bg && isLightColor(v.bg) ? "black" : undefined,
          flex: "1",
          lineHeight: "1",
        }}
      >
        {v.statusDisplayName}
      </div>
    )
  })

  return (
    <>
      {dutyRosters}
      {absences}
      {cell.text ? renderCellText(cell.text! as any, null as any) : null}
    </>
  )
}
